import { getID } from "src/libs/utilities"

 

const image = (): any[] => {
    return [
        {
          "id": getID("img"), 
          "type": "image",
          "src": "https://i.pinimg.com/736x/6b/a2/ec/6ba2ec9eb2a8edd2bbdb14a29921dcd4.jpg",
          "src_type": "src",
          "height": "auto",
            defaultTitle: "Обычное изображение"
        },
        {
          "id": getID("img"),
          "hover_size": 10,
          "type": "image",
          "src": "https://i.pinimg.com/1200x/d6/5f/5d/d65f5d2dfa7bad96b63aa1c263632af6.jpg",
          "src_type": "div",
          "link_url": "https://ru.pinterest.com/pin/54395107994341733/",
          "link_target": "_blank",
          "description": "Некоторые из самых выдающихся мыслителей критически относятся к языковым моделям, отвергая их как простых имитаторов, неспособных порождать по-настоящему оригинальные идеи.",
          "description_title": "Февраль. Достать чернил и плакать!",
          "height": 400,
            defaultTitle: "Пространство, залитое изображением с комментарием"
        },
        {
          "id": getID("img"),
          "hover_size": 10,
          "type": "image",
          "src": "https://i.pinimg.com/1200x/44/d3/da/44d3da58da343d4e570513ae9b22c235.jpg",
          "src_type": "src",
          "link_url": "https://ru.pinterest.com/pin/1407443629419562/",
          "link_target": "_blank",
          "description": "<p>В 1960-х годах люди активно обсуждали, каким может быть будущее, и нигде это волнение не проявлялось так ярко, как в футуристических концепциях домов той эпохи. Одним из выдающихся художников был Чарльз Шридд, чьи работы для рекламы Motorola рисовали (в буквальном смысле!) дома, словно сошедшие со страниц научно-фантастического фильма.</p><p>В работах Шридде были представлены дома (по всей видимости, построенные по проектам нескольких известных архитекторов), которые отличались смелым дизайном, элегантностью и, несомненно, крутостью. Разумеется, на всех рекламных плакатах были изображены стереосистемы, телевизоры и другая электроника Motorola, а сами плакаты публиковались в национальных журналах в начале 1960-х годов.</p><p>Но что делало эти произведения искусства особенно яркими, так это то, как они играли с пространством и светом. Шридде часто включал в свои проекты природные ландшафты, представляя дома, в которых можно было бы пользоваться новейшими технологиями, не теряя связи с природой. Его работы отражали увлечение технологиями той эпохи, а также желание сделать современную жизнь роскошной и даже немного неземной.",
          "description_title": "Space Age 60’s living room 💚",
          "height": "auto",
          width: "100%",
          is_contrast_muar: true,
          description_style: {
            backgroundColor: "transparent",
            fontSize: ".9em",
            color: "var(--force-contast-color)",
          },
            defaultTitle: "Изображение с муаром к низу"
        },
    ]
}
export default image